import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import action from './action'
Vue.use(Vuex)

const state = {
  lang: 'zh',
  login: false,   // 是否登录
  userInfo: null, // 用户信息
  fullscreenLoading: false,//加载动画
  displayhidingLogin: false, //登录页面是否展示
  displayhidingAccount: false,//账户中心页面是否展示
  order: undefined,//订单编辑
  selectOrderList: [],
  globalLoading: false,//全局加载
  is_state: -1,
  gd_end: -1,
  is_step: 1,
  gd_indo: {},
  //自主设计
  sdphase1: {
    sexData: {},//性别
    category: {},//品类
    style: {
      tdcId: false
    },//风格
    fabricSupply: {},//面料供应
    editionType: [],//版型种类
    processList:[],//工艺
  },
  sdphase2: {
    defaultFabric: {},//设计选择的面料
    design: [],//设计选择的工艺
    designCopy: [],//设计选择的工艺
    conflict: [],//冲突
    craftworkBound: [],//工艺绑定
    collideCurrentTechnology1: {},//冲突工艺
    craftFlag: false
  },
  // 深度设计
  sdphase3: {
    showItems: [],//内容区展现数据
    selected_categoryId: false,//内容区tab栏显示不让用户做其他操作
    drawerName: {},
    design: []
  },
  saveUserData: {//个人信息
    id: '',
    phone: '',
    fullName: '',
    weight: '',
    height: '',
    danhao: '',
    measureStaff: '',
    adresseeInfoId: '',
    addStr:'',
    orderNumber:'',
  },
  selfMassing: {//自主量体
    tailor: [],
    dressStyle: {},
    specials: []
  },
  selfDetermination: {//自主选择
    clothes_size: {},
    size: {},
    tailor: [],
    selfDetermination: []
  },
  sdphaseType: -1,
  wdfabricDefault: {},//选择面料
  wddesign: [],//选择工艺
  wddesignCopy: [],//选择工艺复制
  goodsData: {},//商品信息
  threeD: {},// 3D 数据
  is_picture: '',// 3D图片
  editCommodity: {
    phone: '',
    fullName: '',
    weight: '',
    height: '',
    danhao: '',
    measureStaff: '',
    addStr:''
  },//购物车编辑
  clearCacheTdcIds: []
}

export default new Vuex.Store({
  state,
  action,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js